import {Redirect, Route, Switch, useRouteMatch} from 'react-router-dom';
import {RolePermissionType} from '../../../../../../backend/enums/role-permission-type';
import {ScreenPaths} from '../../../../../../enums';
import PermissionsRequiredRoute from '../../../../../../components/permissions-required-route';
import SeniorStatisticsProfessionalCaregiverOfficeScreen from './statistics/senior-statistics.professional-caregiver.screen';
import SeniorStatisticsHealthProfessionalCaregiverOfficeScreen from './statistics/senior-statistics-health.professional-caregiver.screen';
import {useAuth} from '../../../../../../contexts/auth/context';
import SeniorActivityProfessionalCaregiverOfficeScreen from './activity/senior-activity.professional-caregiver.screen';

export default function SeniorDashboardProfessionalCaregiverOfficeScreen() {
  let {path, url} = useRouteMatch();
  const availablePath = useFirstAvailableDashboardPath(url);

  return (
    <Switch>
      <PermissionsRequiredRoute
        exact
        path={`${path}${ScreenPaths.Senior_Dashboard_Activity}`}
        requiredPermissions={[
          {
            type: RolePermissionType.Seniors_Dashboard_Activity,
            canRead: true, // users must be able to at least read senior activity to access the page
          },
        ]}
      >
        <SeniorActivityProfessionalCaregiverOfficeScreen />
      </PermissionsRequiredRoute>

      <PermissionsRequiredRoute
        exact
        path={`${path}${ScreenPaths.Senior_Dashboard_General}`}
        requiredPermissions={[
          {
            type: RolePermissionType.Seniors_Dashboard_GeneralStatistics,
            canRead: true,
          },
        ]}
      >
        <SeniorStatisticsProfessionalCaregiverOfficeScreen />
      </PermissionsRequiredRoute>

      <PermissionsRequiredRoute
        exact
        path={`${path}${ScreenPaths.Senior_Dashboard_Health}`}
        requiredPermissions={[
          {
            type: RolePermissionType.Seniors_Dashboard_HealthStatistics,
            canRead: true,
          },
        ]}
      >
        <SeniorStatisticsHealthProfessionalCaregiverOfficeScreen />
      </PermissionsRequiredRoute>

      {/* --- Fallback Route ---*/}
      <Route path={path}>
        <Redirect to={availablePath} />
      </Route>
    </Switch>
  );
}

// -------------------------------------------------------------------------
// -------------------------------------------------------------------------
// -------------------------------------------------------------------------

function useFirstAvailableDashboardPath(url: string) {
  const {hasReadPermission} = useAuth();

  // If the user has access to the Activity page, redirect to it
  if (hasReadPermission(RolePermissionType.Seniors_Dashboard_Activity)) {
    return `${url}${ScreenPaths.Senior_Dashboard_Activity}`;
  }

  // If the user has access to the General Statistics page, redirect to it
  if (hasReadPermission(RolePermissionType.Seniors_Dashboard_GeneralStatistics)) {
    return `${url}${ScreenPaths.Senior_Dashboard_General}`;
  }

  // If the user has access to the Health Statistics page, redirect to it
  if (hasReadPermission(RolePermissionType.Seniors_Dashboard_HealthStatistics)) {
    return `${url}${ScreenPaths.Senior_Dashboard_Health}`;
  }

  // Fallback
  return `${url}${ScreenPaths.Senior_Dashboard_General}`;
}
